'use strict';

// Click handler for the right-of-withdrawal popup. The popup markup is rendered
// by `app_hsng/cartridge/templates/default/components/withdrawalPopup.isml` next
// to every `hsng-usps` content asset. The `[data-withdrawal-popup]` trigger
// lives inside that content asset (managed in Business Manager).
module.exports = function () {
    var OPEN_CLASS = 'is-open';

    function getPopup(container) {
        return container && container.querySelector('.withdrawal-popup');
    }

    function setOpen(container, isOpen) {
        if (!container) {
            return;
        }
        container.classList.toggle(OPEN_CLASS, isOpen);
        var popup = getPopup(container);
        if (popup) {
            popup.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
    }

    function closeAll(except) {
        document.querySelectorAll('.withdrawal-popup-container.' + OPEN_CLASS).forEach(function (el) {
            if (el !== except) {
                setOpen(el, false);
            }
        });
    }

    function toggle(owner) {
        var wasOpen = owner.classList.contains(OPEN_CLASS);
        closeAll(wasOpen ? null : owner);
        setOpen(owner, !wasOpen);
    }

    document.addEventListener('click', function (e) {
        var closeBtn = e.target.closest('.withdrawal-popup-close');
        if (closeBtn) {
            var closeContainer = closeBtn.closest('.withdrawal-popup-container');
            setOpen(closeContainer, false);
            var closeTrigger = closeContainer && closeContainer.querySelector('[data-withdrawal-popup]');
            if (closeTrigger) {
                closeTrigger.focus();
            }
            return;
        }

        var trigger = e.target.closest('[data-withdrawal-popup]');
        var owner = trigger && trigger.closest('.withdrawal-popup-container');
        if (owner) {
            e.preventDefault();
            toggle(owner);
            return;
        }

        if (!e.target.closest('.withdrawal-popup')) {
            closeAll(null);
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAll(null);
            return;
        }

        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            var trigger = e.target.closest('[data-withdrawal-popup]');
            var owner = trigger && trigger.closest('.withdrawal-popup-container');
            if (owner) {
                e.preventDefault();
                toggle(owner);
            }
        }
    });
};
